<template>
  <div>
    <h1 class="common__main-title">Add Schedule</h1>
    <div class="common__sub-title">
      <span>Add</span>
    </div>
    <TutorInfo :tutor="tutor"/>
    <div class="content-wrapper">
      <ValidationObserver ref="observer">
        <InputForm :scheduleId="$route.params.scheduleId" v-model="schedule" />
      </ValidationObserver>
        <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{
            name:'TimesheetDetail',
            params: { tutorId: $route.params.tutorId },
          }"
        >
            Back
          </b-button>
          <b-button
            pill
            variant="primary"
            @click="formValidate"
          >
            Confirm
          </b-button>
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { ValidationObserver } from 'vee-validate'
import { Tutor } from '@/store/tutors/types'
import TutorInfo from '@/components/parts/TutorInfo.vue'
import InputForm from '@/components/parts/schedules/InputForm.vue'

export default Vue.extend({
  components: {
    ValidationObserver,
    TutorInfo,
    InputForm,
  },

  data() {
    return {
      schedule: null,
    }
  },

  computed: {
    tutor(): Tutor {
      return this.$store.getters.findTutorById(this.$route.params.tutorId)
    },
  },
  created() {
    this.$store.dispatch('getTutor', { tutorId: this.$route.params.tutorId })
  },

  methods: {
    /* inputformのバリデーションを実行(veeValidate) */
    formValidate() {
      (this.$refs.observer as any).validate()
        .then((result: any) => {
          if (result !== true) {
            // 問題があれば何もしない
            return
          }

          this.$router.push({
            name: 'AddScheduleConfirm',
            params: {
              tutor: JSON.stringify(this.tutor),
              editingSchedule: JSON.stringify(this.schedule),
            },
          })
        });
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}
</style>
